// storage.ts
import createWebStorage from 'redux-persist/lib/storage/createWebStorage';
import type { Storage } from 'redux-persist';

// fallback storage for server side (no-op)
const createNoopStorage = (): Storage => {
  return {
    getItem() {
      return Promise.resolve(null);
    },
    setItem() {
      return Promise.resolve();
    },
    removeItem() {
      return Promise.resolve();
    },
  } as Storage;
};

let storage: Storage;

if (typeof window !== 'undefined') {
  try {
    // Use IndexedDB if available
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const createIdbStorage = require('@piotr-cz/redux-persist-idb-storage').default;

    storage = createIdbStorage({
      name: `${process.env.NEXT_PUBLIC_ENVIRONMENT}_aioApp_DB`,
      storeName: 'keyval',
    });
  } catch (error) {
    console.error('Failed to initialize IndexedDB, falling back to localStorage:', error);
    // fallback to localStorage inside browser
    storage = createWebStorage('local');
  }
} else {
  // Always use NOOP storage on the server
  storage = createNoopStorage();
}

export default storage;
